/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import 'extensions/ui-components/x-loader';
import {defineCustomElement} from 'extensions/utils';
import {LitElement, html, nothing} from 'lit';
import {DEFAULT_TITLE, DIAMOND_STEP, SETTING_STEP} from '../../data/constants';
import {ringBuilderStore} from '../../data/ring-builder-store';
import styles from './ring-builder.component.scss?as=stylesheet';

class RingBuilder extends MobxReactionUpdate(LitElement) {

	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			heading: {
				type: String
			},
			store: {
				state: true,
				type: Object
			}
		};
	}

	constructor () {
		super();

		this.heading = DEFAULT_TITLE;

		// Set default value placeholder for store
		this.store = {};
	}

	firstUpdated () {
		// Initialize the store
		this.initStore();
	}

	async initStore () {
		this.store = await ringBuilderStore;

		// Expose api to window for debugging
		if (this.store.debug) {
			window.RingBuilder = this;
		}

		// Set initial loading status
		setTimeout(() => {
			this.store.setLoaded(true);
		}, 150);
	}

	renderLoader () {
		return html`<x-loader class="loader" aspect-ratio-desktop="5/3" aspect-ratio-tablet="5/3" aspect-ratio="5/5"></x-loader>`;
	}

	renderSelectedStep () {
		switch (this.store?.step) {
			case DIAMOND_STEP:
				if (!this.store?.loaded) {
					return this.renderLoader();
				}

				return html`<rb-diamond-product-listing .compareList="${this.store?.diamond?.compareList}" compare-no-results-message="Please select some diamonds to compare." results-no-results-message="Unfortunately we couldn't find any diamonds that match your selected criteria. Please contact us to speak to an expert who can help you find the perfect diamond." list-type="diamond" .service="${this.store?.diamond?.searchService}" .store="${this.store}" api-endpoint="${this.store.apiEndpoint}"></rb-diamond-product-listing>`;
			case SETTING_STEP:
				if (!this.store?.loaded) {
					return this.renderLoader();
				}

				return this.renderSettingStep();
			default:
				if (!this.store?.loaded && !window.mivaJS?.Screen?.includes('PROD')) {
					return this.renderLoader();
				}

				return nothing;
		}
	}

	renderSettingStep () {
		let message = `Unfortunately we couldn't find any settings that match your selected criteria. Please contact us to speak to an expert who can help you find the perfect setting.`;

		if (this.store?.setting?.searchService?.store?.state?.selectedFacets?.length === 0 && this.store?.diamond?.product?.id) {
			message = `Unfortunately there are no compatible ring settings based on the diamond you have selected. Please contact us to speak to an expert who can help you find the perfect setting.`;
		}

		return html`<rb-setting-product-listing .compareList="${this.store?.setting?.compareList}" compare-no-results-message="Please select some settings to compare." results-no-results-message="${message}" list-type="setting" .service="${this.store?.setting?.searchService}" .store="${this.store}" api-endpoint="${this.store.apiEndpoint}"></rb-setting-product-listing>`;
	}

	render () {
		return html`
			<div class="ring-builder-inner">
				<rb-status-bar heading="${this.heading}" .store="${this.store}"></rb-status-bar>
				${this.renderSelectedStep()}
			</div>
			<rb-toasts .messages="${this.store?.messagesStore?.messages}"></rb-toasts>
		`;
	}
}

defineCustomElement('ring-builder', RingBuilder);
